<div class="container h-100">
	<div class="row h-100 justify-content-center align-items-center">
		<div class="col-8 text-center">
			<div><i class="fa fa-bug"></i><span>404</span></div>
			<h1>Page not found</h1>
			<h2>We're sorry, the page you requested could not be found. Please go back to the <a href="/">homepage</a> or
				contact us at <a href="mailto:it.helpdesk@paramountenterprise.co.id">it.helpdesk&#64;paramountenterprise.co.id</a>.</h2>
		</div>
	</div>
</div>
